import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { EDIT_TEMPLATE_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
interface EditTemplateRequest {
  templateType: string;
  title: string;
  message: string | null;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutEditTemplate = ({ onSuccess, onError, uuid }: Input) => {
  const putEditTemplate = async (requestData: EditTemplateRequest) => {
    const res = await axiosClient.put<void>(EDIT_TEMPLATE_URL(uuid), requestData);
    return res.data;
  };

  return useCustomMutation(
    putEditTemplate,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
